import defaultsDeep from "lodash/defaultsDeep"

const DEF_OPTS = {
    "base_url": "/",
    "api_url": "/tree",
    "mode": "full",
    "node_id": "IT-XXX-XXXX",
    "parents": "IT-XXX-XXXX,IT-XXX-XXXX",
};

const OPTS = defaultsDeep({}, window.TREENAV_OPTIONS, DEF_OPTS);

export default OPTS;